import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-termination-date-adoption-date",
  // imports: [],
  templateUrl: "./termination-date-adoption-date.component.html",
  styleUrl: "./termination-date-adoption-date.component.css",
  standalone: false,
})
export class TerminationDateAdoptionDateComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
